module.exports = "<div style=\"margin-left:50%;margin-top:214px;\">\n\t<md-progress-circular class=\"md-primary md-hue-1\" md-diameter=\"30\"></md-progress-circular>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/olr-mainfe-landing/index.html
 ** module id = 201
 ** module chunks = 1
 **/